<script setup lang="ts">
import { Pane, Splitpanes } from 'splitpanes'
import { useDeviceBreakpoint } from '../../composables/useDeviceBreakpoint'
import UAppBar from './UAppBar.vue'
import 'splitpanes/dist/splitpanes.css'

withDefaults(defineProps<Props>(), {
  showLeft: true,
  showRight: true,
  showToggle: true,
})

const breakpoint = useDeviceBreakpoint()

interface Props {
  showToggle?: boolean
  showLeft?: boolean
  showRight?: boolean
  title?: string
}
const mobile = computed(() => breakpoint.smaller('tablet').value)

const DRAWER_EXPANDED_DEFAULT = 20
const navSize = ref(mobile.value ? 0 : DRAWER_EXPANDED_DEFAULT)
const mainSize = computed(() => 100 - navSize.value)

function toggleDrawer(): void {
  if (navSize.value <= 1) {
    if (mobile.value) {
      navSize.value = 100
    }
    else {
      navSize.value = DRAWER_EXPANDED_DEFAULT
    }
  }
  else {
    navSize.value = 0
  }
}

watch(mobile, () => {
  if (mobile.value) {
    navSize.value = 0
  }
})
</script>

<template>
  <v-layout :class="{ 'is-mobile': mobile }">
    <!-- <v-system-bar color="deep-purple darken-3"></v-system-bar> -->

    <UAppBar :show-toggle-drawer="showToggle" :left-drawer-size="navSize" :title="title" @toggle-drawer="toggleDrawer()" />

    <Splitpanes class="up-theme" style="max-height: 100vh;" @resize="navSize = $event[0].size;">
      <Pane v-if="showLeft" :size="navSize" style="padding-top: 64px; display: flex;flex-direction: column;" class="drawer-pane">
        <div class="d-flex" style="height: 100%">
          <div style="flex:1; overflow-y: auto" class="tree-view-wrapper">
            <slot name="left" />
          </div>
        </div>
      </Pane>
      <Pane v-if="showRight" :size="mainSize">
        <v-main style="display: flex;flex-direction: column; height: 100%">
          <div style="display: flex; flex-direction: column; flex-grow: 1; overflow: auto">
            <slot name="right" />
          </div>
        </v-main>
      </Pane>
    </Splitpanes>
  </v-layout>
</template>

<style scoped>
.link{
  text-transform: none !important;
}

.up-theme.splitpanes--vertical > .splitpanes__splitter,
.up-theme .splitpanes--vertical > .splitpanes__splitter {
  background-color: rgba(var(--v-theme-on-background), 0.2);
  box-sizing: border-box;
  position: relative;
  min-width: 3px;
  flex-shrink: 0;
}

.splitpanes.up-theme .splitpanes__splitter {
  background-color: rgba(var(--v-theme-on-background), 0.2);
  box-sizing: border-box;
  position: relative;
  min-width: 3px;
  flex-shrink: 0;
}

.splitpanes--vertical > .splitpanes__splitter {
  min-width: 2px;
  cursor: col-resize;
}

.is-mobile .splitpanes__splitter {
  display: none;
}

.tonal-primary-bg {
  background-color: rgba(var(--v-theme-primary), 0.7);
}

.tree-view-wrapper {
  min-width: 200px;
  overflow-y: auto;
  overflow-x: hidden;

  .is-mobile & {
    overflow-x: auto;
  }
}

.is-mobile .tree-view-wrapper {
  .v-list-item-title {
    text-overflow: unset !important;
  }

  > .v-list {
    width: max-content;
    min-width: 100%;
  }

  .treeview-scrollbox .v-list-item__content {
    overflow: unset !important;
  }

  .treeview-scrollbox .v-list-group__items {
    width: max-content;
  }
}
</style>
